import React from 'react';
import { Calendar, Home } from 'lucide-react';

// ============================================================
// DAILY LIMIT CONSTANT - Keep in sync with backend rate_limiter.py
// ============================================================
const DAILY_QUESTION_LIMIT = 300;

/**
 * Modal shown when user hits their daily question limit.
 */
const DailyLimitModal = ({ show, onGoHome }) => {
    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
                {/* Header */}
                <div className="bg-gradient-to-r from-blue-500 to-indigo-500 p-6 text-white text-center">
                    <Calendar className="w-12 h-12 mx-auto mb-3" />
                    <h2 className="text-xl font-bold">Daily Limit Reached</h2>
                </div>

                {/* Content */}
                <div className="p-8 text-center">
                    <p className="text-gray-700 text-lg mb-2">
                        Great work today!
                    </p>
                    <p className="text-gray-600 mb-6">
                        You've answered <span className="font-semibold text-indigo-600">{DAILY_QUESTION_LIMIT} questions</span> today.
                        <br />
                        Come back tomorrow to continue learning!
                    </p>

                    <button
                        onClick={onGoHome}
                        className="flex items-center justify-center gap-2 mx-auto px-6 py-3 rounded-xl font-semibold bg-gradient-to-r from-blue-500 to-indigo-500 text-white hover:shadow-lg transition-all"
                    >
                        <Home className="w-5 h-5" />
                        Back to Home
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DailyLimitModal;
